var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-col',{staticClass:"palette-preview"},[_c('v-row',{staticClass:"color-row",attrs:{"justify":"space-around"}},[(_vm.colors.length == 0)?_c('div',[_c('h2',{staticClass:"empty-message"},[_vm._v("No colors here")])]):_vm._e(),_vm._l((_vm.colors),function(color){return _c('div',{key:color,style:(_vm.styles[color])})})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }